import React from 'react';

export default function JsonViewer({ data, title }) {
  return (
    <div className="card">
      {title && <h3 className="text-lg font-semibold mb-3 text-gray-900">{title}</h3>}
      <pre className="bg-gray-50 p-4 rounded-lg overflow-x-auto text-sm text-gray-800">
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
}
